import {useLocation, useNavigate} from "react-router-dom";
import {TabBar} from "antd-mobile";
import {getBottomNavBarContainerStyle} from "../../../utils/deviceUtils";

export type Item = {
    path: string;
    icon: React.ReactNode;
    label: string;
}

interface PathNavigationTabBarProps {
    items: Item[];
}


export const PathNavigationTabBar: React.FC<PathNavigationTabBarProps> = ({items}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const {pathname} = location;

    const setRouteActive = (value: string) => {
        navigate(value);
    };

    return (
        <div {...getBottomNavBarContainerStyle('flex-none border-t border-gray-300')}>
            <TabBar activeKey={pathname} onChange={value => setRouteActive(value)}>
                {
                    items.map(item => (
                        <TabBar.Item key={item.path} icon={item.icon} title={item.label}/>
                    ))
                }
            </TabBar>
        </div>
    );
};

export default PathNavigationTabBar;